import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    relaunchLeague,
    reJoinLeague,
    previousSeasonDeleteLeague,
    previousSeasonMemberDeleteLeague,
    updateFavouriteTeam,
} from './../../actions/LeagueActions';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import OutsideNotifier from '../../OutsideNotifier';
import ClubSelector from './ClubSelector';

class LeagueHomePageCard extends Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
        this.onSkipClubSelection = this.onSkipClubSelection.bind(this);
        this.onSubmitClub = this.onSubmitClub.bind(this);
        this.state = {
            showToolTipID: null,
            tooltipActive: false
        };
    }

    componentWillReceiveProps(nextProps) {
        // if((!nextProps.clubData || (nextProps.clubData && nextProps.clubData.length <= 0)) && nextProps.isPublic && nextProps.leagues && nextProps.leagues.length && (nextProps.leagues.findIndex((league)=>{return league.TypeId == 3 && league.ShowList == 1}) >= 0)){
        //     this.getClubsList();
        // }
    }

    onTooltipOutsideClick = () => {
        if (this.hasMultipleTooltips && this.clickedOnTT) {
            this.clickedOnTT = false;
            return;
        }
        this.setState(() => {
            return { showToolTipID: null };
        })
    };
    onTooltipClick = (leagueID) => {
        if (this.hasMultipleTooltips) {
            this.clickedOnTT = true;
        }

        this.setState({ showToolTipID: leagueID }, () => {
            if (this.state.showToolTipID) {
                common.customTracking('Helper');
            }
        })
    };
    goToSettings = (e, leagueID) => {
        e.stopPropagation();
        common.customTracking('League Settings');
        return this.props.history.push('/league-settings/' + leagueID);
    };
    goToLeagueLeaderBoard = (leagueID) => {
        common.customTracking('View League');
        return this.props.history.push('/league-leaderboard/' + leagueID);
    };
    goToPublicLeagueLeaderBoard = (TypeId) => {
        common.customTracking('View League');
        const CountryId = common.getDataFromCookie('CountryId');
        const FavSoccerTeamId = common.getDataFromCookie('FavSoccerTeamId');
        return this.props.history.push('/public-leaderboard/' + TypeId + '/' + CountryId + '/' + FavSoccerTeamId);
    };
    onReActiveClick = (LeagueId, leagueCode) => {
        common.customTracking('Restart League');
        const GUID = common.getGUID();
        common.showLoader();
        this.props.relaunchLeague(GUID, LeagueId, leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.relaunchLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.reActivate[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                this.props.getLeagues();
                this.props.handleToast({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.props.handleToast(stateToSet);
            }
        });
    };
    onReJoinClick = (LeagueId, leagueCode, LeagueName) => {
        common.customTracking('Rejoin League ');
        const GUID = common.getGUID();
        common.showLoader();
        this.props.reJoinLeague(GUID, LeagueId, leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.reJoinLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.reJoin[retVal];
            const message = this.props.trans[errorKeyFromTrans].replace('{{leagueName}}', LeagueName);
            if (response.Meta['Success'] && ([1, 2].indexOf(retVal) >= -1)) {
                this.props.getLeagues();
                this.props.handleToast({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.props.handleToast(stateToSet);
            }
        });
    };
    onDeletePreviousLeagueClick = (LeagueId, leagueCode) => {
        common.customTracking('Delete League', '/uclfantasy/leagues/private/settings/');
        const GUID = common.getGUID();
        common.showLoader();
        this.props.previousSeasonDeleteLeague(GUID, LeagueId, leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.previousSeasonDeleteLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.deletePreviousLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                this.props.getLeagues();
                this.props.handleToast({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.props.handleToast(stateToSet);
            }
        });
    };
    onDeletePreviousMembersLeagueClick = (LeagueId, leagueCode) => {
        common.customTracking('Delete Previous Member League');
        const GUID = common.getGUID();
        common.showLoader();
        this.props.previousSeasonMemberDeleteLeague(GUID, LeagueId, leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.previousSeasonMemberDeleteResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.deletePreviousMembersLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                this.props.getLeagues();
                this.props.handleToast({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.props.handleToast(stateToSet);
            }
        });
    };

    toggleTooltip() {

        this.setState({ tooltipActive: !this.state.tooltipActive }, () => {
            if (this.state.tooltipActive) {
                common.customTracking("Helper")
            }
        })
    }

    closeTooltip() {
        this.setState({ tooltipActive: false })
    }

    getGlobalLeagueIcons(league) {
        switch (league.TypeId) {
            case 1:
                return <i className="icon-ucl-global_league"></i>
            case 2:
                return <i className="icon-ucl-country_league"></i>
            case 3:
                if (league.TeamId) {
                    return <img src={ config.UEFAImgBase + "teams/logos/140x140/" + league.TeamId + ".png" } />
                }
                else {
                    return <i className="icon-ucl-default-icon"></i>
                }
            case 4:
                return <img src={ config.playerImgBase + "leagues/winner.png" } />
            default:
                return null
        }
    }

    getClubsList() {
        if (this.props.fetchClubs) {
            this.props.fetchClubs()
        }
    }

    onSkipClubSelection() {
        if (this.props.updateFavouriteTeam) {
            this.props.updateFavouriteTeam(2)
        }
    }

    onSubmitClub(club) {
        if (this.props.updateFavouriteTeam) {
            this.props.updateFavouriteTeam(1, club)
        }
    }

    render() {
        const { leagues, trans, headText, isPublic, length, constraints, isPrevSeasonLeagues } = this.props;
        const { showToolTipID } = this.state;
        const isCollapsed = length > 2;
        let isLeaderboard = false;
        let showClubs = false;
        let leaguesMarkup = leagues.map((league, index) => {
            let { LeagueId, LeagueName, Rank, Trend, LeagueCode, IsRequested, MemberRequest, IsUserAdmin, isPreviousSeason, TotalMembers, ShareLoad, IsDefaultLeague, TypeId } = league;
            IsRequested = +IsRequested === 1;
            const IsAdmin = +IsUserAdmin === 1;
            const showCard = +TotalMembers === 1 && !common.isEndOfSeason(constraints.GamercardSubScenario);
            const showToolTip = showToolTipID === LeagueId;
            const tooltipClass = common.makeClasses({
                'si-icon-wrap': true,
                'si-que-mrk': true,
                'si-active': showToolTip
            });
            let isEot = common.isEndOfSeason(constraints.GamercardSubScenario);
            if (+IsDefaultLeague === 1) {
                //LeagueName = trans['defaultLeagueName'].replace('{TEAM_NAME}', LeagueName);
            }
            if (isPrevSeasonLeagues) {
                if (IsAdmin) {
                    return (
                        <div className="si-league-body">
                            <div className="si-rejoin-wrap" key={ LeagueId }>
                                <div className="si-title-wrp">
                                    <div className="si-title">{ LeagueName }</div>
                                    <div className={ tooltipClass } onClick={ () => this.onTooltipClick(LeagueId) }>
                                        <i className="icon-ucl-info" />
                                        { showToolTip ? <OutsideNotifier
                                            handler={ () => this.onTooltipOutsideClick() }>
                                            <div className="si-tooltip">
                                                <span>{ trans['you_were_admin_tooltip'] }</span>
                                            </div>
                                        </OutsideNotifier> : null }
                                    </div>
                                </div>
                                <div className="si-no-members">
                                    { trans['members_requested_count'].replace('{COUNT}', MemberRequest) }
                                </div>
                                <div className="si-btn-wrp">
                                    <div className="si-btn si-btn-primary"
                                        onClick={ () => this.onReActiveClick(LeagueId, LeagueCode) }>
                                        <span>{ trans['reactive'] }</span>
                                    </div>
                                    <div className="si-btn si-btn-secondary"
                                        onClick={ () => this.onDeletePreviousLeagueClick(LeagueId, LeagueCode) }>
                                        <span>{ trans['delete'] }</span>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
                if (!IsAdmin && !IsRequested) {
                    return (
                        <div className="si-league-body">
                            <div className="si-rejoin-wrap" key={ LeagueId }>
                                <div className="si-title-wrp">
                                    <div className="si-title">{ LeagueName }</div>
                                    <div className={ tooltipClass } onClick={ () => this.onTooltipClick(LeagueId) } >
                                        <i className="icon-ucl-info" />
                                        { showToolTip ? <OutsideNotifier
                                            handler={ () => this.onTooltipOutsideClick() }>
                                            <div className="si-tooltip">
                                                <span>{ trans['you_were_part_tooltip'] }</span>
                                            </div>
                                        </OutsideNotifier> : null }
                                    </div>
                                </div>
                                <div className="si-no-members">
                                    { trans['members_requested_count'].replace('{COUNT}', MemberRequest) }
                                </div>
                                <div className="si-btn-wrp">
                                    <div className="si-btn si-btn-primary"
                                        onClick={ () => this.onReJoinClick(LeagueId, LeagueCode, LeagueName) }>
                                        <span>{ trans['rejoin'] }</span>
                                    </div>
                                    <div className="si-btn si-btn-secondary"
                                        onClick={ () => this.onDeletePreviousMembersLeagueClick(LeagueId, LeagueCode) }>
                                        <span>{ trans['delete'] }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                if (IsRequested) {
                    return (
                        <div className="si-league-body">
                            <div className="si-rejoin-wrap" key={ LeagueId }>
                                <div className="si-title-wrp">
                                    <div className="si-title">{ LeagueName }</div>
                                    <div className={ tooltipClass } onClick={ () => this.onTooltipClick(LeagueId) } >
                                        <i className="icon-ucl-info" />
                                        { showToolTip ? <OutsideNotifier
                                            handler={ () => this.onTooltipOutsideClick() }>
                                            <div className="si-tooltip">
                                                <span>{ trans['you_were_part_tooltip'] }</span>
                                            </div>
                                        </OutsideNotifier> : null }
                                    </div>
                                </div>
                                <div className="si-no-members">
                                    { +MemberRequest === 1 ? trans['you_requested_count'] : trans['you_and_members_requested_count'].replace('{COUNT}', (MemberRequest - 1)) }
                                </div>
                                <div className="si-desc">
                                    { trans['requested'] }
                                </div>
                            </div>
                        </div>
                    )
                }
            }
            if (isPublic || isCollapsed) {/*More than 2 leagues*/
                let GUID = common.getGUID();
                let myObj = league.Members && league.Members.length ? league.Members.find((m) => { return m.GUID == GUID }) : null
                //commented make not
                const rankToDisplay = isPublic ? Rank : myObj ? myObj['Rank'] : null;
                const handler = isPublic ?
                    (league['IsPointCalculated'] ?
                        {
                            onClick: () => this.goToPublicLeagueLeaderBoard(TypeId)
                        } : {})
                    : { onClick: () => this.goToLeagueLeaderBoard(LeagueId) };
                const trendClass = (isPublic ? config.trend[Trend] : (myObj && TotalMembers > 1 ? config.trend[myObj.Trend] : ""))
                if (!LeagueName) return null;
                if (TypeId == 3 && league.ShowList == 1) {
                    showClubs = true;
                }
                //commented make not
                let leagueClickableClass = ((isPublic && !league['IsPointCalculated']) ? "" : "si-cursor-pointer")
                return (
                    <React.Fragment key={ LeagueId }>
                        {
                            (TypeId == 3 && league.ShowList == 1)
                                ?
                                //Clubs 
                                null
                                :
                                <div className={ "si-league-row " + leagueClickableClass } { ...handler } key={ index }>
                                    <div className="si-league-wrp">
                                        <div className="si-league-left">
                                            { this.getGlobalLeagueIcons(league) }
                                        </div>
                                        <div className="si-league-right">
                                            <span className="si-league-item">{ LeagueName }</span>
                                            <span className={ "si-league-rank " + (TotalMembers > 1 ? "" : "si-no-count") }>
                                                {
                                                    (
                                                        TotalMembers > 1
                                                            ?
                                                            common.memberNotation(TotalMembers) + " "
                                                            :
                                                            "No "
                                                    ) + (trans['members'] || "members")
                                                }</span>
                                        </div>
                                    </div>
                                    <div className="si-rank-section">
                                        { (rankToDisplay && TotalMembers > 1) ? <span>#{ (rankToDisplay || '-') }</span> : <span>-</span> }
                                        { trendClass ? <i className={ "icon-ucl-position si-rank-icons " + trendClass } /> : <i className="icon-ucl-position si-rank-icons" /> }
                                        { leagueClickableClass == "" ? null : <i className="icon-ucl-arrow_left si-arrow"></i> }
                                    </div>
                                </div>
                        }
                    </React.Fragment>
                )
            } else {/*Expanded version*/
                if (showCard) {

                    let singleMemberLeagueMarkup = (
                        <div className="si-league-body" key={ LeagueId }>
                            <div className="si-share-card" >
                                <div className="si-share-wrp">
                                    <div className="si-name-wrap">
                                        <span>{ LeagueName }</span>
                                    </div>
                                    <div className="si-no-members">
                                        <span>{ trans['noOtherMembers'] || "No other members for now" }</span>
                                    </div>
                                </div>
                                <div className="si-join-code">
                                    <span className="si-title">{ trans['toInviteFriends'] || "To invite friends to this league, share the code" }</span>
                                    <div className="si-code-wrp">
                                        <span>{ LeagueCode }</span>
                                        <OutsideNotifier handler={ () => this.onTooltipOutsideClick() }>
                                            <span className={ tooltipClass } onClick={ (e) => this.onTooltipClick(LeagueId) }>
                                                <i className="icon-ucl-info"></i>
                                                <div className="si-tooltip">
                                                    <div className="si-tt-desc">{ trans['share_code_tooltip'] }</div>
                                                </div>
                                            </span>
                                        </OutsideNotifier>
                                    </div>
                                </div>
                                <div className="si-btn-wrp" style={ isEot ? common.hideVisibility() : {} } onClick={ (e) => this.props.showSharePopup(e, LeagueCode, LeagueId, LeagueName, ShareLoad, true) }>
                                    <div className="si-btn si-btn-primary si-share-btn">
                                        <span>
                                            <i className="icon-ucl-share"></i>
                                            { trans['share_code'] }
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="si-league-footer" onClick={ () => this.goToLeagueLeaderBoard(LeagueId) }>
                                <span>{ trans['view_Leaderboard'] || "View Leaderboard" }</span>
                                <i className="icon-ucl-arrow_left"></i>
                            </div>
                        </div>
                    )
                    if (leagues.length == 2) {
                        this.hasMultipleTooltips = true;
                        return (
                            <div key={ 1 } className="si-leagues-card">
                                { singleMemberLeagueMarkup }
                            </div>
                        )
                    }
                    else {
                        return (singleMemberLeagueMarkup);
                    }
                } else {
                    const members = league.Members || [];
                    const PointsGamedayId = league['PointsGamedayId'];
                    isLeaderboard = true;
                    let leagueCardMarkup = (
                        <div className="si-league-body" key={ LeagueId }>
                            <div className="si-league-row si-league-row-head">
                                <span className="si-league-item">{ LeagueName }</span>
                            </div>
                            <div className="si-leaderboard">
                                <div className="si-board-head">
                                    <div className="si-row">
                                        <div className="si-block si-name-wrp">
                                            <div className="si-rank">
                                                <span className="">{ trans['rank'] }</span>
                                            </div>
                                        </div>
                                        <div className="si-block si-right-data ">
                                            <div className="si-cell">{ trans['total'] }</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="si-board-body si-body">
                                    {
                                        members.map((eachMember) => {
                                            const { UserId, Trend, GUID, UserName, TeamName, BadgeId, CurrentGDPoints, Points, Rank } = eachMember;
                                            let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                                            const trendClass = config.trend[Trend];
                                            const isUserSelf = GUID === common.getGUID();
                                            const wrapperClass = common.makeClasses({
                                                'si-data-row': true,
                                                'si-tRow': true,
                                                'si-current-user': isUserSelf
                                            });
                                            const name = UserName + (isUserSelf ? ' ' + trans['you'] : '');
                                            return (
                                                <div className={ "si-data-row si-row " + (isUserSelf ? "si-current-user " : "") }>
                                                    <div className="si-block si-name-wrp">
                                                        <div className=" si-rank">
                                                            <span className={ trendClass }>{ (Rank || '-') }</span>
                                                        </div>
                                                        <div className="si-plyr-info-wrap">
                                                            <div className="si-plyr-info">
                                                                <div className="si-badge-wrap">
                                                                    {/* <img src={imgSrc} alt={UserId} /> 
                                                                    <div className="si-member-num">
                                                                        <span>12</span>
                                                                    </div>*/}
                                                                </div>
                                                                <div className="si-names">
                                                                    <span className="si-name-one">{ TeamName }</span>
                                                                    <span className="si-user-name">{ name }</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="si-block si-right-data ">
                                                        <div className="si-cell">{ (Points || '-') }</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="si-league-footer" onClick={ () => this.goToLeagueLeaderBoard(LeagueId) }>
                                    <span>{ trans['view_leaderboard'] }</span>
                                    <i className="icon-ucl-arrow_left" />
                                </div>
                            </div>
                        </div>


                        // ---- Old Code ----
                        // <div className="si-leaderBrd-card" key={LeagueId}
                        //     onClick={() => this.goToLeagueLeaderBoard(LeagueId)}>
                        //     <div className="si-name-wrap">
                        //         <span>{LeagueName}</span>
                        //         <i className="icon-ucl-add-member"
                        //             style={isEot ? common.hideVisibility() : {}} onClick={(e) => this.props.showSharePopup(e, LeagueCode, LeagueId, LeagueName, ShareLoad)} />
                        //     </div>
                        //     <div className="si-leaderboard si-tbl">
                        //         <div className="si-tHead si-board-head">
                        //             <div className="si-tRow">
                        //                 <span className="si-tCel si-rank">{trans['rank']}</span>
                        //                 <span className="si-tCel si-plyr-info-wrap" />
                        //                 <span
                        //                     className="si-tCel si-md">{trans['matchday'] + ' ' + PointsGamedayId}</span>
                        //                 <span className="si-tCel si-total">{trans['total']}</span>
                        //             </div>
                        //         </div>
                        //         <div className="si-board-body si-tBody">
                        //             {members.map((eachMember) => {
                        //                 const { UserId, Trend, GUID, UserName, TeamName, BadgeId, CurrentGDPoints, Points, Rank } = eachMember;
                        //                 let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
                        //                 const trendClass = config.trend[Trend];
                        //                 const isUserSelf = GUID === common.getGUID();
                        //                 const wrapperClass = common.makeClasses({
                        //                     'si-data-row': true,
                        //                     'si-tRow': true,
                        //                     'si-current-user': isUserSelf
                        //                 });
                        //                 const name = UserName + (isUserSelf ? ' ' + trans['you'] : '');
                        //                 return <div className={wrapperClass} key={UserId}>
                        //                     <div className="si-block si-tCel si-rank">
                        //                         <span className={trendClass}>{(Rank || '-')}</span>
                        //                     </div>
                        //                     <div className="si-block si-plyr-info-wrap si-tCel">
                        //                         <div className="si-plyr-info">
                        //                             <div className="si-badge-wrap">
                        //                                 <img src={imgSrc} alt={UserId} />
                        //                             </div>
                        //                             <div className="si-names">
                        //                                 <span
                        //                                     className="si-name-one">{TeamName}</span>
                        //                                 <span className="si-user-name">{name}</span>
                        //                             </div>
                        //                         </div>
                        //                     </div>
                        //                     <div className="si-block si-md si-tCel">
                        //                         <span className="">{(CurrentGDPoints || '-')}</span>
                        //                     </div>
                        //                     <div className="si-block si-total si-tCel">
                        //                         <span className="">{(Points || '-')}</span>
                        //                     </div>
                        //                 </div>
                        //             })}
                        //         </div>
                        //     </div>
                        //     <div className="si-league-footer">
                        //         <span>{trans['view_leaderboard']}</span>
                        //         <i className="icon-ucl-arrow_left" />
                        //     </div>
                        // </div>
                    )

                    if (leagues.length == 2) {
                        return (
                            <div key={ 2 } className="si-leagues-card si-leaderboard-card">
                                { leagueCardMarkup }
                            </div>
                        )
                    } else {
                        return (leagueCardMarkup)
                    }

                }
            }
        });

        let leagueHeadMarkup = (
            <React.Fragment>
                {
                    (!this.props.hideTitle && headText && headText.length)
                        ?
                        <div className="si-league-head">
                            <span className="si-league-title">{ headText }</span>
                            {
                                (leagues && leagues.length > 0)
                                    ?
                                    <OutsideNotifier handler={ this.closeTooltip }>
                                        <span className={ "si-icon-wrap si-que-mrk " + (this.state.tooltipActive ? "si-active" : "") } onClick={ this.toggleTooltip }>
                                            <i className="icon-ucl-info"></i>
                                            {
                                                (isPublic)
                                                    ?
                                                    <div className="si-tooltip">
                                                        <div className="si-tt-desc">{ trans['tooltipDescPublicLeague'] || "Climb the leaderboard and see how you perform against other players. The global rank league is a public league thet all players enter by default." }</div>
                                                    </div>
                                                    :
                                                    <div className="si-tooltip">
                                                        <div className="si-tt-head">{ trans['tooltipTitlePrivateLeague'] || "Play with friends" }</div>
                                                        <div className="si-tt-desc">{ trans['tooltipDescPrivateLeague'] || "These are leagues that you or your friends created. New players need an invite code or link to join." }</div>
                                                    </div>
                                            }

                                        </span>
                                    </OutsideNotifier>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </React.Fragment>
        )

        if (leagues.length) {
            if (!isPrevSeasonLeagues && !isPublic && leagues.length == 2) {
                return (
                    <div className="si-leagues-dual">
                        { leagueHeadMarkup }
                        <div className="si-leagues-wrp">
                            { leaguesMarkup }
                        </div>
                    </div>
                )
            } else {
                return (
                    <React.Fragment>
                        <div className={ "si-leagues-card " + (isLeaderboard ? "si-leaderboard-card " : " ") + (isPublic ? " " : "si-private-leagues ") }>
                            { leagueHeadMarkup }
                            {
                                (isPrevSeasonLeagues)
                                    ?
                                    leaguesMarkup
                                    :
                                    (isPublic || isCollapsed)
                                        ?
                                        <div className="si-league-body">
                                            <div className="si-league-list si-manage-card" >
                                                {
                                                    (leagues && leagues.length)
                                                        ?
                                                        <div className="si-league-row si-league-row-head" >
                                                            <span className="si-league-item">{ trans['leagueNameTitle'] || "League Name" }</span>
                                                            <div className="si-rank-section">
                                                                <span className="">{ trans['rankTitle'] || "Rank" }</span>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                { leaguesMarkup }
                                            </div>
                                        </div>
                                        :
                                        leaguesMarkup
                            }
                        </div>
                        {
                            (showClubs)
                                ?
                                <ClubSelector
                                    clubs={ this.props.clubs }
                                    trans={ this.props.trans }
                                    onSkip={ this.onSkipClubSelection }
                                    onSubmit={ this.onSubmitClub }
                                />
                                :
                                null
                        }
                    </React.Fragment>
                )
            }

        }
        else {
            return null
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        relaunchLeague: (GUID, LeagueId, leagueCode) => dispatch(relaunchLeague(GUID, LeagueId, leagueCode)),
        reJoinLeague: (GUID, LeagueId, leagueCode) => dispatch(reJoinLeague(GUID, LeagueId, leagueCode)),
        previousSeasonDeleteLeague: (GUID, LeagueId, leagueCode) => dispatch(previousSeasonDeleteLeague(GUID, LeagueId, leagueCode)),
        previousSeasonMemberDeleteLeague: (GUID, LeagueId, leagueCode) => dispatch(previousSeasonMemberDeleteLeague(GUID, LeagueId, leagueCode)),
        updateFavouriteTeam: (optType, club) => dispatch(updateFavouriteTeam(optType, club))
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        relaunchLeagueResponse: state.leaguesData.relaunchLeagueResponse,
        reJoinLeagueResponse: state.leaguesData.reJoinLeagueResponse,
        previousSeasonDeleteLeagueResponse: state.leaguesData.previousSeasonDeleteLeagueResponse,
        previousSeasonMemberDeleteResponse: state.leaguesData.previousSeasonMemberDeleteResponse,
        constraints: state.appData.constraints,
        // clubData : state.clubData
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeagueHomePageCard));


// WEBPACK FOOTER //
// ./src/components/leagues/LeagueHomePageCard.js